import { MILLION, ONE_DAY } from "shared/constants";

export const getDifferenceBetweenNanosecInDays = (start: number, end: number) => {
  return Math.ceil((new Date(end / MILLION).getTime() - new Date(start / MILLION).getTime()) / ONE_DAY);
};
